<template>
  <dialog-component
    :dialogData="dialogData"
    :isShow="isShow"
    :isUnitButton = 'true'
    @cancel="isShow=false"
  >
    <div class="email-dialog">
      <email-tree
        :companies="companies"
        :email="email"
        :is-link="true"
        :customerId="customerId"
        @handleLink="handleLink"
      ></email-tree>
    </div>
  </dialog-component>
</template>

<script>
import emailTree from './email-tree'
export default {
  name: 'linkAccountEmailDialog',
  components:{
    emailTree
  },
  props:{
    companies:{
      type:Array,
      default:()=>([])
    },
    email:{
      type:String,
      default:''
    },
    customerId:{
      type:[Number,String],
      default:''
    }
  },
  data(){
    return{
      isShow:false
    }
  },
  computed:{
    dialogData(){
      return{
        title:'Linked Accounts',
      }
    }
  },
  methods:{
    handleShow(){
      this.isShow = !this.isShow
    },
    handleLink(){
      this.isShow = false
      this.$emit('refresh')
    }
  }
}
</script>

<style scoped lang="scss">
  .email-dialog{
    ::v-deep .email-content{
      margin-top: 0;
    }
  }
</style>
